import { CommonModule } from '@angular/common';
import { Component, HostBinding, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NavigationButton } from '../../header-v2.component';

@Component({
  standalone: true,
  selector: 'app-header-v2-navigation',
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './header-v2-navigation.component.html',
  styleUrl: './header-v2-navigation.component.scss',
})
export class HeaderV2NavigationComponent {
  buttons = input<ReadonlyArray<NavigationButton>>();
  /** Center the blue nav pill in the header (admin mobile). */
  centered = input(false);

  @HostBinding('class.navigation--centered')
  get centeredClass(): boolean {
    return this.centered();
  }

  trackByIcon = (_: number, item: NavigationButton): string => item.icon;
}
